var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.625V25",
    stroke: "#D849B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.119 29.6875L25 25",
    stroke: "#D849B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9702 19.4766H43.7827V11.6641",
    stroke: "#D849B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1534 37.1534C34.7497 39.5571 31.6872 41.1941 28.3531 41.8573C25.0191 42.5204 21.5632 42.1801 18.4226 40.8792C15.282 39.5783 12.5977 37.3753 10.7091 34.5489C8.82053 31.7224 7.8125 28.3994 7.8125 25C7.8125 21.6006 8.82053 18.2776 10.7091 15.4511C12.5977 12.6247 15.282 10.4217 18.4226 9.12083C21.5632 7.81995 25.0191 7.47958 28.3531 8.14276C31.6872 8.80594 34.7497 10.4429 37.1534 12.8466L43.7825 19.4757",
    stroke: "#D849B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReview);
export default __webpack_public_path__ + "static/media/PendingReview.7636d42bba78e217819b7c54396b372d.svg";
export { ForwardRef as ReactComponent };